import { publicComponentOption } from "dependencies/base"
import { toSelectOpt } from "utils"
const optDes = {
  ...publicComponentOption,
  content: "内容",
  linkUrl: "跳转地址",
  openBlankPage: "新开页面跳转",
  fontFamily: "字体",
  fontSize: "字体大小",
  fontStyle: "字体样式",
  lineHeight: "行高",
  fontWeight: "字重",
  textAlign: "对齐方式",
  writingMode: "排列方式",
  bgColor: "背景颜色",
  color: "字体颜色",
  colorType: "字体颜色类型",
  textIsThemeColor: "字体颜色跟随主题色",
  startColor: "渐变色开始色值",
  endColor: "渐变色结束色值",
  colorlinearGradientAngle: "渐变色渐变角度",
  letterSpacing: "字间距",
  textDecoration: "下划线",
  textIndent: "文本缩进",
  textOverFlowType: "文本超出可见",
  paddingTop: "上边距",
  paddingRight: "右边距",
  paddingLeft: "左边距",
  paddingBottom: "下边距",
  borderTopLeftRadius: "左上角圆角",
  borderTopRightRadius: "右上角圆角",
  borderBottomLeftRadius: "左下角圆角",
  borderBottomRightRadius: "右下角圆角",
  borderStyle: "边框类型", // solid dashed dotted
  borderColor: "边框颜色",
  borderWidth: "边框宽度",
  borderIsThemeColor: "边框颜色跟随主题色",
  updateTimer: "数据轮询时间",
  restDataUrl: "外接数据源地址",
  boxShadowColor: "边框阴影颜色",
  boxShadowH: "阴影x轴的偏移量",
  boxShadowV: "阴影y轴的偏移量",
  boxShadowBlur: "阴影模糊值",
  boxShadowSpread: "阴影扩散值"
}
export const getOptDes = toSelectOpt.bind(this, optDes)
